module.exports = __webpack_public_path__ + "img/img3.4ebd2464.png";